import type { TLngLat, TValuesTimeseriesPoints } from 'App/Map/types'
import type { TProperty } from 'stores/fieldAssetStore/helperTypes'

type TPointsBody = {
  lngLats: TLngLat[]
  valuesRequested: Record<string, { preferredAggregationInterval: string }>
}

export const getPointsBody = (options: {
  lngLats: TLngLat[]
  interval: string
  property: TProperty
  valueTypes: string[]
}): TPointsBody => {
  const { lngLats, interval, property, valueTypes } = options

  return lngLats.reduce<TPointsBody>(
    (pointsBody, lngLat) => {
      const point = property?.points?.[lngLat]

      if (!point?.valuesTimeseries) {
        return pointsBody
      }

      let includePoint = false

      valueTypes.forEach((valueType) => {
        if (point.valuesTimeseries.includes(valueType as TValuesTimeseriesPoints)) {
          includePoint = true

          if (!pointsBody.valuesRequested[valueType]) {
            let preferredAggregationInterval = interval

            if (valueType === 'leafWetnessHours' && interval === 'HOURLY') {
              preferredAggregationInterval = 'UNAGGREGATED'
            }

            pointsBody.valuesRequested[valueType] = { preferredAggregationInterval }
          }
        }
      })

      if (includePoint && !pointsBody.lngLats.includes(lngLat)) {
        pointsBody.lngLats.push(lngLat)
      }

      return pointsBody
    },
    { lngLats: [], valuesRequested: {} },
  )
}
